document.addEventListener('click', event => {
    const button = event.target.closest('[data-ap-image]');
    if (!button) return;
    const image = document.getElementById('ap-main-image');
    image.src = button.dataset.apImage;
    image.alt = button.querySelector('img').alt;
    document.querySelectorAll('[data-ap-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
});

(() => {
 const colors = {Espresso:'#49302b',Darknight:'#232526','Lucky Jade':'#116655','Mia Pink':'#e8bcc6','Pinot Noir':'#551e30'};
 const images = {Espresso:0,Darknight:5,'Lucky Jade':6,'Mia Pink':7,'Pinot Noir':8};
 document.addEventListener('change', event => {
  if(event.target.id !== 'ap-variant') return;
  const option = event.target.selectedOptions[0];
  document.querySelector('[data-ap-color-name]').textContent = option.dataset.color;
  document.querySelectorAll('[data-ap-swatch]').forEach(radio => { radio.checked = radio.value === option.value; });
  const thumb = document.querySelectorAll('[data-ap-image]')[images[option.dataset.color]];
  if(thumb) { const image=document.getElementById('ap-main-image'); image.src=thumb.dataset.apImage; image.alt=thumb.querySelector('img').alt; document.querySelectorAll('[data-ap-image]').forEach(t=>t.setAttribute('aria-pressed',String(t===thumb))); }
  const submit = document.querySelector('[data-ap-submit]');
  submit.disabled = option.dataset.available !== 'true';
  submit.textContent = submit.disabled ? 'Currently unavailable' : 'Add to Cart';
 });
 function initDelivery(){
  document.querySelectorAll('[data-ap-delivery]').forEach(card=>{
   const flag=card.querySelector('[data-country-flag]');
   if(flag && /^[A-Z]{2}$/.test(flag.dataset.countryFlag)) flag.textContent=String.fromCodePoint(...Array.from(flag.dataset.countryFlag,c=>127397+c.charCodeAt(0)));
   const date = new Date();
   const format = new Intl.DateTimeFormat(document.documentElement.lang || 'en',{month:'short',day:'numeric'});
   const first = new Date(date); first.setDate(first.getDate()+5);
   const last = new Date(date); last.setDate(last.getDate()+7);
   card.querySelector('[data-ap-delivery-dates]').textContent = format.format(first)+' – '+format.format(last);
  });
 }
 initDelivery(); document.addEventListener('shopify:section:load',initDelivery);
})();

// Keep the main photo in sync with the last colour chosen inside Kaching.
document.addEventListener('click', event => {
 const option = event.target.closest('kaching-bundle [role="option"]');
 if (!option) return;
 const colour = option.textContent.trim();
 const position = {Espresso:0,Darknight:5,'Lucky Jade':6,'Mia Pink':7,'Pinot Noir':8}[colour];
 if(position !== undefined) { const thumb=document.querySelectorAll('[data-ap-image]')[position]; const image=document.getElementById('ap-main-image'); if(!thumb || !image) return; image.src=thumb.dataset.apImage; image.alt=thumb.querySelector('img').alt; document.querySelectorAll('[data-ap-image]').forEach(t=>t.setAttribute('aria-pressed',String(t===thumb))); }
}, true);

document.addEventListener('change', event => {
 if (!event.target.matches('[data-ap-swatch]')) return;
 const select = document.getElementById('ap-variant');
 if (!select) return;
 select.value = event.target.value;
 select.dispatchEvent(new Event('change', {bubbles:true}));
});

// Same Ajax add-and-render flow as the leggings page, using the test-only drawer.
(() => {
 const form = document.getElementById('ap-product-form');
 const drawer = () => document.querySelector('cart-drawer');
 const root = window.Shopify?.routes?.root || '/';
 let busy = false;
 async function refreshBadge() {
  try { const r=await fetch(root+'cart.js'); if(!r.ok)return; const cart=await r.json(); document.querySelectorAll('[data-ap-cart-count]').forEach(el=>el.textContent=cart.item_count); } catch (_) {}
 }
 document.addEventListener('click',event=>{
  const link=event.target.closest('[data-ap-cart]');
  if(!link || !drawer()?.open || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
  event.preventDefault();drawer().open(link);
 });
 form?.addEventListener('submit',async event=>{
  event.preventDefault();
  if(busy || !form.reportValidity())return;
  const button=form.querySelector('[data-ap-submit]');
  const status=form.querySelector('[data-ap-cart-status]');
  const id=form.querySelector('[name=id]');
  if(!id?.value)return;
  busy=true;button.disabled=true;button.textContent='Adding to your bag…';status.textContent='';
  try {
   const cart=drawer();
   cart?.setActiveElement(button);
   const payload={items:[{id:Number(id.value),quantity:Number(form.querySelector('[name=quantity]')?.value || 1)}],sections:['sw-test-cart'],sections_url:location.pathname};
   const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
   const data=await response.json();
   if(!response.ok)throw new Error(data.description || data.message || 'Could not add this item. Please try again.');
   // The add succeeded. A failed render must never trigger a second add.
   try {
    if(!data.sections?.['sw-test-cart']){const rendered=await fetch(root+'?sections=sw-test-cart');data.sections=await rendered.json();}
    cart.renderContents(data);refreshBadge();
   } catch (_) {
    status.textContent='Added to your bag. ';
    const link=document.createElement('a');link.href=root+'cart';link.textContent='View your bag';status.append(link);
   }
  } catch(error) {
   status.textContent=/cannot find variant/i.test(error.message)?'This product is not available for purchase yet. Please try again once it is available.':error.message;
  } finally {busy=false;button.disabled=id.selectedOptions?.[0]?.dataset.available==='false';button.textContent='Add to Cart';}
 });
 const cart=drawer();
 if(cart)new MutationObserver(refreshBadge).observe(cart,{childList:true,subtree:true});
})();

// Kaching does not infer custom colour names; share the product's swatch palette.
(() => {
 const palette={Espresso:'#49302b',Darknight:'#232526','Lucky Jade':'#116655','Mia Pink':'#e8bcc6','Pinot Noir':'#551e30'};
 function syncBundleSwatches(){
  const bundle=document.querySelector("kaching-bundle");
  if(bundle)bundle.id="ap-bundles";
  document.querySelectorAll('kaching-bundle [role="option"],kaching-bundle [role="combobox"]').forEach(option=>{
   const color=palette[option.dataset.value || option.textContent.trim()];
   const swatch=option.querySelector('.kaching-bundles__swatch');
   if(!color || !swatch)return;
   if(swatch.style.getPropertyValue('--kaching-swatch-color')!==color)swatch.style.setProperty('--kaching-swatch-color',color);
   if(swatch.style.getPropertyValue('--kaching-swatch-border-color')!==color)swatch.style.setProperty('--kaching-swatch-border-color',color);
  });
 }
 syncBundleSwatches();
 const scope=document.getElementById('MainContent');
 if(scope)new MutationObserver(syncBundleSwatches).observe(scope,{childList:true,subtree:true,characterData:true});
})();

// Show the floating purchase link only after scrolling past the main CTA.
(() => {
 const sticky=document.querySelector('.ap-mobile-buy');
 const button=document.querySelector('[data-ap-submit]');
 if(!sticky || !button)return;
 const update=()=>{sticky.hidden=button.getBoundingClientRect().bottom>0;};
 let frame;
 window.addEventListener('scroll',()=>{if(frame)return;frame=requestAnimationFrame(()=>{frame=null;update();});},{passive:true});
 new IntersectionObserver(update,{threshold:0}).observe(button);
 window.addEventListener('resize',update,{passive:true});
 update();
})();

document.addEventListener('click',event=>{
 const link=event.target.closest('.ap-mobile-buy a');
 if(!link)return;
 const bundle=document.querySelector('kaching-bundle');
 if(!bundle)return;
 event.preventDefault();event.stopImmediatePropagation();
 bundle.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
},true);
